import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';

import { useModuleController } from '../../../hooks/controllers/module-public-controller';
import { Background, MainContainer } from './layout-candidate-styled';
import { LayoutFooterCandidate } from './layout-candidate/footer-candidate/footer-candidate';
import { LayoutHeaderCandidate } from './layout-candidate/header-candidate/header-candidate';

export const LayoutCandidate = ({ children, pageSettings, moduleId }) => {
  const { isAuthenticated } = Sebrae.useAuth();
  const { getQueryString } = Sebrae.useRouter();
  const { getSettingsModule } = useModuleController();

  const [settings, setSettings] = React.useState(pageSettings);

  React.useEffect(() => {
    const moduleId = getQueryString('module');

    if (moduleId) {
      getSettingsModule(+moduleId)
        .then((response) => {
          setSettings(response?.settingsMap);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [getQueryString, getSettingsModule]);
  return (
    <Background
      isAuthenticated={isAuthenticated}
      primaryColor={settings?.primaryColor}
      imgBackground={settings?.empretecGraphics}
    >
      <LayoutHeaderCandidate moduleId={moduleId} />
      <MainContainer
        isAuthenticated={isAuthenticated}
        secondaryColor={settings?.secondaryColor}
      >
        {children}
      </MainContainer>
      <LayoutFooterCandidate />
    </Background>
  );
};
